/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HomeRoutes {
  ROUTE_ACCREDITATION = '/credenciamento/:nrSeqAccreditation/tipo-credenciamento/:nrSeqTypeAccreditation',
  ROUTE_NEGOTIATION_DRAFT = '/historico-negociacoes/negociacao/:nrSeqNegotiation/proposta/:nrSeqProposal/minuta-contratual',
  ROUTE_NEGOTIATION_TABCONTROL = '/historico-negociacoes/negociacao/:nrSeqNegotiation/proposta/:nrSeqProposal/negociacao-valores',
  ROUTE_ROUTES = '/',
  ROUTE_TECHNICAL_VISIT_APPOINTMENTS = '/visita-tecnica/:nrSeqVisit/agendamentos',
  ROUTE_TECHNICAL_VISIT_FORMS = '/visita-tecnica/:nrSeqVisit/formularios/:nrSeqForm',
  ROUTE_TECHNICAL_VISIT_INCONSISTENCIES = '/visita-tecnica/:nrSeqVisit/inconsistencias',
}
export { HomeRoutes };
